export default __webpack_public_path__ + "static/media/insert-block-amico.59251357.png";